import React from 'react';

import type { Props as InputProps } from './Input';
import Input from './Input';

export interface NumberInputProps extends InputProps {
  min?: number;
  max?: number;
  step?: number;
}

const Numbers: React.FC<NumberInputProps> = (props) => <Input {...props} type="number" />;

export default Numbers;
